import { Typography } from '@mui/material'

const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

export function TimezoneNote({ timezone }: { timezone: string }) {
  if (timezone === browserTimezone) return null
  return (
    <Typography variant="caption" color="text.secondary">
      Heures locales de l'événement ({timezone})
    </Typography>
  )
}
